import {Component, ViewEncapsulation,OnInit, ViewChild } from '@angular/core';
import {Location, LocationStrategy, PathLocationStrategy} from '@angular/common';
import {CartService} from './services/cart.service';
import {Observable} from 'rxjs';
import {Product} from './classes/product';
import * as firebase from 'firebase';
import { DoctorchatrequestComponent } from './doctorchatrequest/doctorchatrequest.component';
import { UserchatrequestComponent } from './userchatrequest/userchatrequest.component';
import { MatDialog, MatDialogRef } from '@angular/material';
import { Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import {
  Router,
  // import as RouterEvent to avoid confusion with the DOM Event
  Event as RouterEvent,
  NavigationStart,
  NavigationEnd,
  NavigationCancel,
  NavigationError
} from '@angular/router'
import { MitterService } from './services/mitter.service';
import { CommonService } from './services/common.service';
import { AuthService } from './authentication/auth.service';
import { trigger, state, style, transition, animate} from '@angular/animations';
import { RazorpayService } from './PaymentGateway/razorpay/razorpay.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [
    trigger('visibilityChanged', [
      state('in', style({
        transform: 'translate3d(0, 0, 0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
  ],
    encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit {
  menuState = 'out';
  firebase: any;
  uid: any;
  title = 'app';
  loading = true
  channelId: String;
  messsagetake = 0;
  mitter: any;
  public shoppingCartItems$: Observable<Product[]>;
  
  messaging:any;
  body: any;
  mess :any;
  mess2 : any;
  constructor(public location: Location, private cartService: CartService,
    private router: Router,private commonService:CommonService, private mitterService: MitterService,
  private authService: AuthService, public dialog: MatDialog, private razorpayService: RazorpayService,
  @Inject(PLATFORM_ID) private platformId: Object
   ) {
   
      router.events.subscribe((event: RouterEvent) => {
        this.navigationInterceptor(event)
      });

      this.commonService.loginsuccessvalue.subscribe((x) => {
        const value = x;
        this.uid = this.commonService.getuserId();
        if (x === 1 && this.uid) {
          this.initializeMitter();
        }
      });
      if (isPlatformBrowser(this.platformId)) {
        this.messaging = firebase.messaging();
      
      this.messaging.onMessage(message => {
        this.body = message;
        this.mess = this.body.data.data;

        this.mess2 = JSON.parse(this.mess);


        if(this.mess2['@type'] == 'new-message-payload'){
          if(this.mess2.message.payloadType == 'vn.petcart.notification'){
            var notifpayload=this.mess2.message.messageData.filter(datum => datum.dataType == 'petcart-notification-payload')[0]
            this.CheckTitle(notifpayload.data.title);
          }
        }
     });
    }
  }
  toggleMenu() {
    // 1-line if statement that toggles the value:
    this.menuState = this.menuState === 'out' ? 'in' : 'out';
  }
ngOnInit(){}
     CheckTitle(x){
       console.log('in checktitle');
         const title = x.substr(0,x.indexOf(' ')); // "72"
         const reqid =  x.substr(x.indexOf(' ')+1);
         const userrole = this.authService.getRoleId();
         if(title == 'NewChat' && userrole == 3 ) {
          this.openDoctorCall(reqid);
         }
     }
     openDoctorCall(reqid){
       this.messsagetake = this.messsagetake + 1;
       if(this.messsagetake == 1) {
        const dialogRef = this.dialog.open(DoctorchatrequestComponent, {
          width: '300px',
          height: '300px',
          data: {reqid: reqid}
        });
        dialogRef.afterClosed().subscribe(result => {
          this.messsagetake = 0;
        });
       }

     }
initializeMitter(){
  this.mitterService.synchUser(false)
      .then(() => this.mitter = this.mitterService.getMitter())
}
  navigationInterceptor(event: RouterEvent): void {
    if (event instanceof NavigationStart) {
      this.loading = true;
      
      if(this.menuState == 'in'){
        this.toggleMenu();
      }
    }
    if (event instanceof NavigationEnd) {
      this.loading = false;
      
      window.scrollTo(0, 0);
    }

    // Set loading state to false in both of the below events to hide the spinner in case a request fails
    if (event instanceof NavigationCancel) {
      this.loading = false;
    }
    if (event instanceof NavigationError) {
      this.loading = false;
    }
  }
}
